import React from 'react';
import styles from './styles.module.scss';

interface MobileModalProps {
  isOpen: boolean;
  onClose: () => void;
  onDelete: () => void;
}

const DeleteModal: React.FC<MobileModalProps> = ({ isOpen, onClose, onDelete }) => {
  return (
    <>
      {isOpen && (
        <div className={styles.mobileModalOverlay} onClick={onClose}>
          <div className={styles.mobileModal}>
            <p>Вы уверены что хотите удалить уведомление?</p>
            <div className={styles.buttonContainer}>
              <button onClick={onClose}>Отмена</button>
              <button onClick={onDelete}>Удалить</button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default DeleteModal;
